"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentWorkflowState = void 0;
var DocumentWorkflowState;
(function (DocumentWorkflowState) {
    DocumentWorkflowState["NONE"] = "none";
    DocumentWorkflowState["IN_REVIEW"] = "in_review";
    DocumentWorkflowState["AWAITING_SIGNATURES"] = "awaiting_signatures";
    DocumentWorkflowState["COMPLETED"] = "completed";
})(DocumentWorkflowState || (exports.DocumentWorkflowState = DocumentWorkflowState = {}));
//# sourceMappingURL=documentWorkflowState.enum.js.map